module.exports = __webpack_public_path__ + "img/3hr-01.7952cf90.jpg";